import { Component, ElementRef, HostListener, Input, OnInit, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { ApiSurveyDto } from '../../../../shared/services/api-surveymodel.service';
import { OrganizationStoreService } from '../../../../shared/services/organization-store.service';

@Component({
  selector: 'app-survey-header',
  templateUrl: './survey-header.component.html',
  imports: [ RouterLink, RouterLinkActive ]
})

export class SurveyHeaderComponent implements OnInit {
  openSurveyMenu: boolean = false;
  openTranslationsMenu: boolean = false;

  @Input() survey: ApiSurveyDto | null = null;
  @Input() activeTab: 'builder' | 'cmd' | 'translations' | 'sync' = 'builder';

  private organizationStore = inject(OrganizationStoreService);
  private elementRef = inject(ElementRef);

  constructor() { }

  ngOnInit() {}

  // Organization-level pages (global/email translations) have no survey loaded,
  // so the survey tabs link to the currently selected survey instead.
  get surveyId(): string | null {
    return this.survey?.id ?? this.organizationStore.selectedSurveyId();
  }

  toggleTranslationsMenu(): void {
    this.openTranslationsMenu = !this.openTranslationsMenu;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (this.openTranslationsMenu && !this.elementRef.nativeElement.contains(event.target)) {
      this.openTranslationsMenu = false;
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    this.openTranslationsMenu = false;
  }
}
